/**
 * Escape a value for interpolation into print-window HTML.
 *
 * The print/preview windows are built with template literals and written via
 * document.write / innerHTML. Anything typed by a user (remarks, names, vehicle
 * numbers, batch refs) must be escaped first, or a remark like
 * `<img src=x onerror=...>` runs in the print window of whoever prints it (P1-2).
 */
const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export const escapeHtml = (value) => (
  value === null || typeof value === 'undefined'
    ? ''
    : String(value).replace(/[&<>"']/g, (c) => ESCAPES[c])
);

export default escapeHtml;
